import http from "./http";

// اطلاعات تراکنش‌هایی که داری
export const fetchAllTransactions = () =>
  http.get("/stores/admin-transactions/");

// ⚙️ جزئیات فروشگاه برای یک تراکنش خاص
export const fetchStoreDetailByTransaction = (transactionId) =>
  http.get(`/stores/admin-transactions/${transactionId}/store_detail/`);
